export enum CompanyCellBlock {
  Root = 'CompanyCell',
}
